"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapTopAreaBanners = void 0;
var _tsUtils = require("@ori/ts-utils");
var _constants = require("../constants");
var _sanitizeKey = require("./sanitizeKey");
const mapTopAreaBanners = ({
  data
}) => {
  if (!data?.application?.permanentTopBanners) {
    return undefined;
  }
  const {
    permanentTopBanners
  } = data.application;
  return permanentTopBanners.filter(_tsUtils.isNonNullable).filter(banner => banner.message ?? banner.link?.relativeUrl).map(banner => ({
    title: banner.message ?? '',
    shouldOpenInvitationOffer: banner.link?.relativeUrl === _constants.INVITATION_OFFER_HASH,
    url: (0, _sanitizeKey.sanitizeKey)(banner.link?.relativeUrl ?? '')
  }));
};
exports.mapTopAreaBanners = mapTopAreaBanners;